import { ChainId } from '@xterswap/sdk-core'

export enum ExplorerDataType {
  TRANSACTION = 'transaction',
  TOKEN = 'token',
  ADDRESS = 'address',
  BLOCK = 'block',
}

export function getExplorerName(chainId: ChainId): string {
  switch (chainId) {
    case ChainId.XTERIO_TESTNET:
    case ChainId.XTERIO:
      return 'Xterscan'
    case ChainId.BNB:
      return 'Bscscan'
  }
}

/**
 * Return the explorer link for the given data and data type
 * @param chainId the ID of the chain for which to return the data
 * @param data the data to return a link for
 * @param type the type of the data
 */
export function getExplorerLink(chainId: ChainId, data: string, type: ExplorerDataType): string {
  let prefix = ''
  switch (chainId) {
    case ChainId.XTERIO_TESTNET:
      prefix = 'https://testnet.xterscan.io'
      break
    case ChainId.XTERIO:
      prefix = 'https://bnb.xterscan.io'
      break
    case ChainId.BNB:
      prefix = 'https://bscscan.com'
      break
  }

  switch (type) {
    case ExplorerDataType.TRANSACTION: {
      return `${prefix}/tx/${data}`
    }
    case ExplorerDataType.TOKEN: {
      return `${prefix}/token/${data}`
    }
    case ExplorerDataType.BLOCK: {
      return `${prefix}/block/${data}`
    }
    case ExplorerDataType.ADDRESS:
    default: {
      return `${prefix}/address/${data}`
    }
  }
}
